import _ from "lodash"
import React from "react"
import PropTypes from "prop-types"
import { Select } from "@tencent/spaui"
import { enumMessages } from "@/utils/MessageUtils"

const statusOptions = _.map(enumMessages("OperationMode"), (message) => {
  return {
    value: message.value,
    label: message.message,
  }
})

class orderCreateAccountSelect extends React.Component {
  static propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func,
  }

  render() {
    const { value, onChange, onClear } = this.props

    return <Select data={statusOptions} clear={true} onClear={onClear} value={value} search={false} onChange={onChange} />
  }
}

export default orderCreateAccountSelect
